import { useTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import { useWhatsNewStore } from './whatsNewStore';

/** The app version in the navigation; opens "What's new" (#3315). */
export function AppVersionButton({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation('releases');
  const openWhatsNew = useWhatsNewStore((s) => s.openWhatsNew);
  const version = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '';

  return (
    <Link
      component="button"
      type="button"
      variant="caption"
      color="text.secondary"
      underline="hover"
      aria-label={t('versionButtonLabel', { version })}
      onClick={() => {
        onClick?.();
        openWhatsNew();
      }}
      sx={{ fontSize: '0.65rem', lineHeight: 1 }}
    >
      v{version}
    </Link>
  );
}
